import { render, staticRenderFns } from "./LockList.vue?vue&type=template&id=952aeb88&scoped=true"
import script from "./LockList.vue?vue&type=script&lang=js"
export * from "./LockList.vue?vue&type=script&lang=js"
import style0 from "./LockList.vue?vue&type=style&index=0&id=952aeb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952aeb88",
  null
  
)

export default component.exports